import DashboardTemplateItem from 'pages/Dashboards/DashboardTemplates/dashboardTemplateItem/dashboardTemplateItem';
import { Grid } from '@mui/material';
import { IDashboardTemplateItem } from 'pages/Dashboards/interfaces';
import DashboardListingHeader from 'pages/Dashboards/DashboardListing/Header/Header';
import { getReports } from 'api/reporting';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/constants';
import { useEffect, useMemo } from 'react';
import WithLoader from 'pages/Dashboards/Widgets/withLoader';
import { sortBy } from 'lodash';
import { useSelector } from 'react-redux';
import selectors from 'store/selectors';

function DashboardTemplates() {
  const dashboardTemplatesQuery = useQuery(
    [QUERY_KEYS.GET_DASHBOARD_TEMPLATES],
    getReports,
    { enabled: false },
  );

  const sidebarOpen = useSelector(selectors.getMenuState);

  useEffect(() => {
    dashboardTemplatesQuery.refetch();
  }, []);

  // Sort Data
  const sortedData = useMemo(() => {
    if (dashboardTemplatesQuery?.data?.length > 0) {
      const customOrder = [
        'task-summary',
        'schedule-report',
        'employee-productivity',
        'completed-work-report',
        'template-submissions',
        'template-submission',
      ];
      const sorted = sortBy(dashboardTemplatesQuery.data, (item) =>
        customOrder.indexOf(item?.slug),
      );
      return sorted;
    }

    return [];
  }, [dashboardTemplatesQuery?.data]);

  return (
    <>
      <WithLoader isLoading={dashboardTemplatesQuery.isFetching}>
        <div
          style={{
            display: 'flex',
            overflow: 'auto',
            gap: 20,
            width: `calc(100vw - ${sidebarOpen ? '330' : '150'}px)`,
          }}
        >
          {sortedData?.map((item: IDashboardTemplateItem, i) => {
            return (
              <DashboardTemplateItem key={item.id} item={item} index={i} />
            );
          })}
        </div>
      </WithLoader>
    </>
  );
}

export default DashboardTemplates;
